import React from "react";
import {  Row, Col,  FormGroup, Button, ButtonGroup, InputGroupAddon, InputGroup} from "shards-react";

import RangeDatePicker from "../common/RangeDatePicker";
import { ORDERS_STATUS_LIST_OPTIONS } from "../../core/constants";
import { Filters } from "../../core/orders-lists";
import ExportInfoPrestadorModal from "./export-info-prestador-modal"

class SearchBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: new Filters(props.filters),
      showExportInfoPrestadorModal: false
    };

    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleFilters = this.handleFilters.bind(this);
    this.handleCleanFilters = this.handleCleanFilters.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleCloseExportInfoPrestadorModal = this.handleCloseExportInfoPrestadorModal.bind(this);
    this.handleShowExportInfoPrestadorModal = this.handleShowExportInfoPrestadorModal.bind(this);
  }

  handleKeyPress(event) {
    if (event.which === 13 || event.keyCode === 13)
      this.props.onSearch(this.input.value);
  }

  handleClick() {
    this.props.onSearch(this.input.value);
  }

  handleFilters(e) {
    //const { filters } = this.state
    const { select_status } = this

    const filters = this.state.filters.withMutations( (filters) =>{
        filters.set('stateId', select_status.value);
    })

    this.props.handleFilters(e, filters )
  }

  handleCleanFilters(e) {

    const filters = this.state.filters.withMutations( (filters) =>{
        filters.merge({
          "date_start": "",
          "date_end": "",
          "stateId": ""
        });
    })

    this.props.handleFilters(e,filters)
    this.select_status.value = "";
    this.setState({
      filters
    })
  }

  handleDate({ date_start_value="", date_end_value="" }) {

    const filters = this.state.filters.withMutations( (filters) =>{
      if (date_start_value)
        filters.set('date_start', date_start_value);
      if (date_end_value)
        filters.set('date_end', date_end_value);
    })

    this.setState({
        filters
    });

  }

  handleCloseExportInfoPrestadorModal() {
      this.setState({
        showExportInfoPrestadorModal: false
      })
  }

  handleShowExportInfoPrestadorModal() {
    this.setState({
      showExportInfoPrestadorModal: true
    })
  }

  render() {
    const { filters } = this.state

    if ( !filters )
      return null;

    return (
        <>
      <Row className="pt-4 pb-2">
        <Col className="col-md-9">
          <Row>
            <FormGroup className="col-md-3">
              <RangeDatePicker handleDate={this.handleDate} startDate={filters.date_start} endDate={filters.date_end} />
            </FormGroup>
            <FormGroup className="col-md-2">
              <select  ref={ n => this.select_status = n }  defaultValue={filters.stateId} className="form-control custom-select form-control-sm custom-select-sm">
                <option value="">Estado</option>
                {ORDERS_STATUS_LIST_OPTIONS.map( item => (
                 <option key={item.id} value={item.id}>{item.label}</option>
                ))}
              </select>
            </FormGroup>
            <ButtonGroup size="sm" className="col-md-7 d-table">
              <Button  onClick={ this.handleFilters } > Filtrar </Button>
              <Button  onClick={ this.handleCleanFilters } outline theme="secondary" className="mx-auto"> Limpiar </Button>
              <Button  onClick={ this.handleShowExportInfoPrestadorModal } className='noHover btn btn-primary ml-md-4 ml-sm-2'> Exportar <i className="far fa-file-excel ml-1" style={{color: 'green'}}></i></Button>
            </ButtonGroup>
          </Row>
        </Col>
        <Col className="col-md-3">
          <InputGroup className="mb-3">
            <input className="form-control" ref={ n => this.input = n } onKeyPress={(e)=>this.handleKeyPress(e)} type="text"  placeholder="Buscar"   />
            <InputGroupAddon type="append">
              <Button onClick={ this.handleClick }  ><i className="material-icons">search</i></Button>
            </InputGroupAddon>
          </InputGroup>
        </Col>
      </Row>

      <ExportInfoPrestadorModal show={this.state.showExportInfoPrestadorModal} handleClose={this.handleCloseExportInfoPrestadorModal} />
      </>
    );

  }
}

export default SearchBar;
